import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import WorkspaceSettingsPage, {
	matchesToWorkspaceSettingsTab,
	pathToWorkspaceSettingsTab,
} from "@/components/settings/workspace/workspace-settings-page";
import { NotFoundPage } from "@/routes/not-found";

const selectWorkspaceSettingsTab = (state: {
	readonly matches: readonly { readonly routeId: string }[];
	readonly location: { readonly pathname: string };
	readonly resolvedLocation?: { readonly pathname: string };
}): ReturnType<typeof matchesToWorkspaceSettingsTab> =>
	matchesToWorkspaceSettingsTab(state.matches) ??
	pathToWorkspaceSettingsTab(state.location.pathname) ??
	(state.resolvedLocation ? pathToWorkspaceSettingsTab(state.resolvedLocation.pathname) : null);

const WorkspaceLayout = (): JSX.Element => {
	const tab = useRouterState({
		select: selectWorkspaceSettingsTab,
	});
	if (!tab) {
		return <Outlet />;
	}
	return <WorkspaceSettingsPage tab={tab} />;
};

export const Route = createFileRoute("/_app/settings/workspace")({
	component: WorkspaceLayout,
	notFoundComponent: () => <NotFoundPage />,
});
